import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

import './RpmModalSummary.css';

@inject('translationsStore')
@observer
export default class RpmModalSummary extends Component {
  render() {
    const { translationsStore } = this.props;
    const { summary } = this.props;
    let summaryDetail = [];

    if (summary) {
      summaryDetail = [
        [
          {
            label: translationsStore.translate('quickFocus.rpm.summary.allRpm'),
            value: summary.totalRpm,
            className: 'FocusMasterdataValueJumbo',
            style: {
              textTransform: 'capitalize'
            }
          },
          {
            label: translationsStore.translate('quickFocus.rpm.summary.maxRpm'),
            value: summary.maxRpm,
            className: 'FocusMasterdataValueJumbo',
            style: {
              textTransform: 'capitalize'
            }
          }
        ],
        [
          {
            label: translationsStore.translate('quickFocus.rpm.summary.avgRpmDuration'),
            value: moment().startOf('day').seconds(Math.round(summary.durationAvgRpm)).format('H:mm:ss'),
            className: 'FocusMasterdataValueJumbo',
            style: {
              textTransform: 'capitalize'
            }
          },
          {
            label: translationsStore.translate('quickFocus.rpm.summary.avgRpmDistance'),
            value: `${Math.round(summary.avgDistance/1000*100)/100} km`,
            className: 'FocusMasterdataValueJumbo',
            style: {
              textTransform: 'capitalize'
            }
          }
        ],
        [
          {
            label: translationsStore.translate('quickFocus.rpm.summary.avgRpm'),
            value: `${Math.round(summary.avgRpm)}`,
            className: 'FocusMasterdataValueJumbo',
            style: {
              textTransform: 'capitalize'
            }
          }
        ]
      ];
    }

    return (
      <div className="RpmModalSummary">
        <div className="FocusMasterdata">
          {summaryDetail.map((item, index) => (
            <div key={index}>
              {item.map((cell, cellIndex) => {
                const className = cell.className ? `FocusMasterdataValue ${cell.className}` : 'FocusMasterdataValue';
                return (
                  <div key={cellIndex} className="FocusMasterdataCell">
                    <div className="FocusMasterdataLabel">
                      {cell.label}:{' '}
                      <div className={className} style={cell.style}>
                        <div>{cell.value}</div>
                      </div>
                    </div>

                    {cell.extra &&
                      cell.extra.map((extra, extraIndex) => (
                        <div key={extraIndex} className="FocusMasterdataExtra">
                          {extra}
                        </div>
                      ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmModalSummary/RpmModalSummary.js